import React from "react";
import { Box } from "@mui/material";
import CustomTruncateText from "../TruncateText/CustomTruncateText";
import type { CustomCellParams } from "./CustomTable";

/**
 * 空の値を「-」で表示する共通のrenderCell関数
 * @param params - CustomCellParams
 * @returns React.ReactNode
 */
export const CustomRenderCellWithDash = (params: CustomCellParams): React.ReactNode => {
  const { value } = params;
  const text = value !== null && value !== undefined ? String(value) : "";
  const trimmed = text.trim();
  return (
    <Box
      sx={{
        width: "100%",
        fontSize: 14,
        fontWeight: 400,
        color: "#3e3e3e",
      }}
    >
      <CustomTruncateText text={trimmed || "-"} />
    </Box>
  );
};

/**
 * 見積金額用のrenderCell関数（空の値、¥0、0の場合に「-」を表示）
 * @param params - CustomCellParams
 * @returns React.ReactNode
 */
export const CustomRenderPriceCellWithDash = (params: CustomCellParams): React.ReactNode => {
  const { value } = params;
  const text = value !== null && value !== undefined ? String(value) : "";
  const trimmed = text.trim();
  
  const displayText =
    !trimmed || trimmed === "¥0" || trimmed === "0" ? "-" : trimmed;
  
  return (
    <Box
      sx={{
        width: "100%",
        fontSize: 14,
        fontWeight: 400,
        color: "#3e3e3e",
      }}
    >
      <CustomTruncateText text={displayText} />
    </Box>
  );
};

